import React from 'react';
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import AppRolesService from "../../General/services/AppRolesService";
import {
    Table,
    TableBody,
    TableBodyCell,
    TableBodyRow,
    TableHead,
    TableHeadCell,
    TableHeadRow
} from "@tag/tag-components-react-v4";

const AdminInfo = () => {
    const {accounts, inProgress} = useMsal();
    const isAuthenticated = useIsAuthenticated();

    while (!inProgress) {
        if (!AppRolesService.isUserAdmin(accounts, isAuthenticated)) {
            throw new Error()
        }
    }

    const renderSignInLogsInfo = () => {
        return (
            <Table style={{width: '50em'}}>
                <TableHead>
                    <TableHeadRow>
                        <TableHeadCell>Environment</TableHeadCell>
                        <TableHeadCell>Link</TableHeadCell>
                    </TableHeadRow>
                </TableHead>
                <TableBody>
                    <TableBodyRow>
                        <TableBodyCell>Local</TableBodyCell>
                        <TableBodyCell>
                            <a target={"_blank"} rel={"noopener noreferrer"} href={'https://portal.azure.com/#view/Microsoft_AAD_IAM/ManagedAppMenuBlade/~/SignIns/objectId/58d50e2e-ea10-4fa1-be66-e7ffd06f0c14/appId/ee08a91d-de6a-4fd7-80db-07ff38f0d48d'}>
                                Link
                            </a>
                        </TableBodyCell>
                    </TableBodyRow>
                    <TableBodyRow>
                        <TableBodyCell>PreProd/Test</TableBodyCell>
                        <TableBodyCell>
                            <a target={"_blank"} rel={"noopener noreferrer"} href={'https://portal.azure.com/#view/Microsoft_AAD_IAM/ManagedAppMenuBlade/~/SignIns/objectId/99e64b01-7079-4811-8d8d-50ef364d304a/appId/ed1b0f4d-aec1-4e3c-b2ab-5663b99d73da'}>
                                Link
                            </a>
                        </TableBodyCell>                    </TableBodyRow>
                    <TableBodyRow>
                        <TableBodyCell>Prod</TableBodyCell>
                        <TableBodyCell>
                            <a target={"_blank"} rel={"noopener noreferrer"} href={'https://portal.azure.com/#view/Microsoft_AAD_IAM/ManagedAppMenuBlade/~/SignIns/objectId/91756721-5ec8-4811-a421-b045bcb8edcc/appId/3db7d407-fec1-4464-bfe3-fc40c4f7d5cf'}>
                                Link
                            </a>
                        </TableBodyCell>                    </TableBodyRow>
                </TableBody>
            </Table>
        )
    }

    const renderLogInfo = () => {
        return (
            <p>
                TODO: Detail how to access logs here
            </p>
        )
    }

    const renderAppServiceManagementInfo = () => {
        return (
            <p>
                TODO: Detail how to access App Service tools (ssh shell, ftp etc.)
            </p>
        )
    }

    return (
        <>
            <h1>Admin Info</h1>
            <div style={{float: 'left', textAlign: 'left'}}>
                <h3>Sign In Logs</h3>
                {renderSignInLogsInfo()}
                <h3>Logs</h3>
                {renderLogInfo()}
                <h3>Azure App Service Management</h3>
                {renderAppServiceManagementInfo()}
            </div>
        </>
    );
}

export default AdminInfo;
